// src/layouts/AdminLayout.jsx
import React from "react";
import { Box } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { AdminNavProvider } from "./AdminNavContext";
import AdminTopBar from "./AdminTopBar";

const TOPBAR_H = 48;

const AdminLayout = () => {
  const { user, isAuthenticated } = useAuth();
  const location = useLocation();

  // 👇 use it here
  const hideTopBar = location.pathname.startsWith("/admin/booking");
  const topbarHeight = hideTopBar ? 0 : TOPBAR_H; // keep sticky offsets correct

  if (!isAuthenticated || !user) return null;

  return (
    <AdminNavProvider>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          // page-level sticky rows read this value
          "--admin-topbar-h": `${topbarHeight}px`,
        }}>
        {/* 👇 conditionally render the global top bar */}
        {!hideTopBar && <AdminTopBar height={TOPBAR_H} />}

        <Box component="main" sx={{ flexGrow: 1 }}>
          <Outlet />
        </Box>
      </Box>
    </AdminNavProvider>
  );
};

export default AdminLayout;
